import { render, staticRenderFns } from "./AlertSupplies.vue?vue&type=template&id=74e41e68"
import script from "./AlertSupplies.vue?vue&type=script&lang=js"
export * from "./AlertSupplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports